module.exports = __webpack_public_path__ + "img/dld-left-a.2c5f5ada.png";